// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result_result__b9YNQ {
  padding-bottom: 120px;
  min-height: calc(100vh - 60px);
  min-height: calc(100dvh);
}

.result_inner__9lJyA {
  max-width: 500px;
  margin: auto;
}

.result_card__AJyTe {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  margin-top: 24px;
  flex-direction: column;
}

.result_product__vjxKB {
  margin-top: 24px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.result_product-title__b7ReQ {
  color: #fff;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 16px;
}

.result_button__VP7S9 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  gap: 9px;
  padding-bottom: 32px;
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.24);
  background: #507687;
  box-shadow: 0px -6px 14px 0px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(8px);
  padding-top: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;
}

.result_button__VP7S9 span {
  font-size: 16px;
}

.result_link__MgNEs {
  background: transparent none repeat 0 0 / auto auto padding-box border-box
    scroll;
  background: initial;
  border: 2px solid #ffd239;
  box-shadow: none;
  align-items: center;
  border-radius: 12px;
  box-shadow: -4px 3px 11px 0 rgba(0, 3, 15, 0.08),
    -17px 11px 20px 0 rgba(0, 3, 15, 0.07),
    -38px 24px 27px 0 rgba(0, 3, 15, 0.04),
    -67px 43px 32px 0 rgba(0, 3, 15, 0.01), -105px 67px 35px 0 rgba(0, 3, 15, 0);
  display: flex;
  gap: 2px;
  height: 56px;
  justify-content: center;
  width: 100%;
  color: #ffd239;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
}

.result_badge__Tqg6t {
  width: 94% !important;
  margin-top: -10px !important;
}

.result_bagdeInner__5ibk6 {
  border-radius: 16px !important;
  padding-top: 24px !important;
  padding-bottom: 24px !important;
  margin-top: 24px;
}



@media screen and (min-width: 1200px) {
  .result_result__b9YNQ {
    padding-bottom: unset;
  }

  .result_badge__Tqg6t {
    width: 48% !important;
  }

  .result_congrate__WVixm {
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 450;
    line-height: 24px;
    /* 120% */
    margin-bottom: 20px;
    margin-top: 40px;
  }

  .result_button__VP7S9 {
    width: 500px;
    margin-top: 24px;
    background: unset;
    box-shadow: unset;
    border: unset;
    position: relative;
    animation: unset !important;
  }

  .result_inner__9lJyA {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1000px;
  }

  .result_product__vjxKB {
    margin-bottom: 80px;
    width: 100%;
  }

  .result_product-title__b7ReQ {
    font-size: 16px;
  }

  .result_card__AJyTe {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/result/result.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,WAAW;EACX,+CAA+C;EAC/C,mBAAmB;EACnB,iDAAiD;EACjD,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;UACQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB;;;gFAG8E;EAC9E,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;;;AAIA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".result {\n  padding-bottom: 120px;\n  min-height: calc(100vh - 60px);\n  min-height: calc(100dvh);\n}\n\n.inner {\n  max-width: 500px;\n  margin: auto;\n}\n\n.card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  margin-top: 24px;\n  flex-direction: column;\n}\n\n.product {\n  margin-top: 24px;\n  padding: 0 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.product-title {\n  color: #fff;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 16px;\n}\n\n.button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 16px;\n  gap: 9px;\n  padding-bottom: 32px;\n  width: 100%;\n  border-top: 1px solid rgba(255, 255, 255, 0.24);\n  background: #507687;\n  box-shadow: 0px -6px 14px 0px rgba(0, 0, 0, 0.12);\n  backdrop-filter: blur(8px);\n  padding-top: 16px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 900;\n}\n\n.button span {\n  font-size: 16px;\n}\n\n.link {\n  background: transparent none repeat 0 0 / auto auto padding-box border-box\n    scroll;\n  background: initial;\n  border: 2px solid #ffd239;\n  box-shadow: none;\n  align-items: center;\n  border-radius: 12px;\n  box-shadow: -4px 3px 11px 0 rgba(0, 3, 15, 0.08),\n    -17px 11px 20px 0 rgba(0, 3, 15, 0.07),\n    -38px 24px 27px 0 rgba(0, 3, 15, 0.04),\n    -67px 43px 32px 0 rgba(0, 3, 15, 0.01), -105px 67px 35px 0 rgba(0, 3, 15, 0);\n  display: flex;\n  gap: 2px;\n  height: 56px;\n  justify-content: center;\n  width: 100%;\n  color: #ffd239;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: center;\n}\n\n.badge {\n  width: 94% !important;\n  margin-top: -10px !important;\n}\n\n.bagdeInner {\n  border-radius: 16px !important;\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n  margin-top: 24px;\n}\n\n\n\n@media screen and (min-width: 1200px) {\n  .result {\n    padding-bottom: unset;\n  }\n\n  .badge {\n    width: 48% !important;\n  }\n\n  .congrate {\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 450;\n    line-height: 24px;\n    /* 120% */\n    margin-bottom: 20px;\n    margin-top: 40px;\n  }\n\n  .button {\n    width: 500px;\n    margin-top: 24px;\n    background: unset;\n    box-shadow: unset;\n    border: unset;\n    position: relative;\n    animation: unset !important;\n  }\n\n  .inner {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 1000px;\n  }\n\n  .product {\n    margin-bottom: 80px;\n    width: 100%;\n  }\n\n  .product-title {\n    font-size: 16px;\n  }\n\n  .card {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"result": `result_result__b9YNQ`,
	"inner": `result_inner__9lJyA`,
	"card": `result_card__AJyTe`,
	"product": `result_product__vjxKB`,
	"product-title": `result_product-title__b7ReQ`,
	"button": `result_button__VP7S9`,
	"link": `result_link__MgNEs`,
	"badge": `result_badge__Tqg6t`,
	"bagdeInner": `result_bagdeInner__5ibk6`,
	"congrate": `result_congrate__WVixm`
};
export default ___CSS_LOADER_EXPORT___;
